import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as moment from 'moment';
import { locale as danish } from "./translate/ds";
import { locale as english } from "./translate/en";

@Component({
    selector: 'project-report',
    templateUrl: './multi-choice-options.component.html',
    styleUrls: ['./multi-choice-options.component.scss']
})


export class MultiChoiceOptionsComponent implements OnInit {

    dataForMultipleChoice: any = [];
    dateFieldsData: any = [];

    constructor(private translationLoaderService: FuseTranslationLoaderService,
        public dialogRef: MatDialogRef<MultiChoiceOptionsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.translationLoaderService.loadTranslations(danish, english);
    }

    ngOnInit() {
        this.dataForMultipleChoice = this.data.dataForMultipleChoice;
        this.dateFieldsData = this.data.dateFields;
    }


    onSelectOption() {
        var result = {
            dataForMultipleChoice: this.dataForMultipleChoice.map(item => ({ placeholder: item.placeholder, selectedKey: item.selectedKey })),
            dateFieldsData: this.dateFieldsData.map(item => ({ placeholder: item.placeholder, selectedDate: moment(item.selectedDate).format('DD.MM.YYYY') }))
        }
        this.onCloseDialog(result);
    }
    onCloseDialog(key) {
        this.dialogRef.close(key)
    }
    CancelPopUp() {
        this.dialogRef.close();
    }
}